
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
    HttpClient
} from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import * as _ from 'lodash';
import * as moment from 'moment';

//Local service file & query file
import { EcommerceOrderService } from '../order/order.service';
import {
    ScheduleQueryService,
    UserQueryService,
    RatingQueryService,
    SettingQueryService,
    BookingsQueryService,
    OcrDumpsQueryService,
    SolutionMasterQueryService,
    InsReportSrcQueryService,
    ReportReviewQueryService,
    SolutionDescriptionQueryService,
    CommonQueryService
} from '../../queryFiles/index';

/**Local file */
import { apiCalls, spekwo, checkoutFields } from '../../utils/index';
import { SolutionDescriptionNodes } from '../../models';
import { AuthService } from '../../authentication/auth.service';
import { SolutionEstimateUsersQueryService } from '../../queryFiles/solutionEstimateUsers';
import { environment } from '../../../../../../environments/environment';
import { AuditHistoryService } from '../../../../../core/services/audit-history.service';

@Injectable()
export class SolutionFormService implements Resolve<any>
{
    apiCalls = apiCalls;
    spekwoValues = spekwo;
    checkoutFields = checkoutFields;

    routeParams: any;

    onCategoryChanged: BehaviorSubject<any> = new BehaviorSubject({});
    chargePercent: BehaviorSubject<any> = new BehaviorSubject({});
    toggledSolution: BehaviorSubject<any> = new BehaviorSubject({ loading: true });
    insReportIdChange: BehaviorSubject<any> = new BehaviorSubject(null);
    isApproveChange: BehaviorSubject<any> = new BehaviorSubject('no');
    ocrDocumentChange: BehaviorSubject<any> = new BehaviorSubject({ loading: true, data: '' });
    currentOrderChanged: BehaviorSubject<any> = new BehaviorSubject(null);
    buyerPropertyChanges: BehaviorSubject<any> = new BehaviorSubject({});
    solutionEmailChanges: BehaviorSubject<any> = new BehaviorSubject('');
    orderTypeChange: BehaviorSubject<any> = new BehaviorSubject({});
    orderProductChange: BehaviorSubject<any> = new BehaviorSubject('');
    clientRoleChange: BehaviorSubject<any> = new BehaviorSubject({});
    clientNameChange: BehaviorSubject<any> = new BehaviorSubject({ loading: true, name: '' });
    clientPropertyRoleChange: BehaviorSubject<any> = new BehaviorSubject({});
    pdfLinkFromCheckout: BehaviorSubject<any> = new BehaviorSubject({ loading: true, data: '' });
    singleOrderChanges: BehaviorSubject<any> = new BehaviorSubject({ loading: true, data: {}, orderInfo: {} });

    PdfLinkChange: any;
    category: any = [];
    orderId: number;
    solutionDescriptionRes: any;
    dueDate: any;

    constructor(private http: HttpClient,
        private ecommerceOrdersService: EcommerceOrderService,
        /** Query files */
        public scheduleQueryService: ScheduleQueryService,
        public userQueryService: UserQueryService,
        public ratingQueryService: RatingQueryService,
        public settingQueryService: SettingQueryService,
        public bookingsQueryService: BookingsQueryService,
        public ocrDumpsQueryService: OcrDumpsQueryService,
        public solutionMasterQueryService: SolutionMasterQueryService,
        public insReportSrcQueryService: InsReportSrcQueryService,
        public reportReviewQueryService: ReportReviewQueryService,
        private _solutionDescriptionQueryService: SolutionDescriptionQueryService,
        private solutionEstimateUsersQueryService: SolutionEstimateUsersQueryService,
        private authService: AuthService,
        public commonQueryService: CommonQueryService,
        public auditHistoryService: AuditHistoryService,
    ) {
    }

    /**
     * The Academy App Main Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise<void>((resolve, reject) => {

            this.routeParams = route.params;

            Promise.all([
                this.getChargePercentage()
            ]).then(
                () => {
                    if (this.routeParams.id) {
                        this.getSingleOrder(Number.parseInt(this.routeParams.id));
                        this.insReportIdOfOrder(Number.parseInt(this.routeParams.id));
                        this.GetOcrDocument(Number.parseInt(this.routeParams.id));
                    }
                    resolve();
                },
                reject
            );
        });
    }
    hoursBasedCost(productCost, discountAmount, paidAmount, createdDate) {
        let dueDate;
        if (productCost == discountAmount + paidAmount) {
            dueDate = moment(new Date(createdDate))
                .add(72, 'hours')
                .format('MM/DD/YYYY');
        }

        else if (productCost + 20 == discountAmount + paidAmount) {
            dueDate = moment(new Date(createdDate))
                .add(48, 'hours')
                .format('MM/DD/YYYY');
        }

        else if (productCost + 40 == discountAmount + paidAmount) {
            dueDate = moment(new Date(createdDate))
                .add(24, 'hours')
                .format('MM/DD/YYYY');
        }
        return dueDate;
    }

    calcDueDate(deliveryTime, createdDate) {
        let dueDate;

        if (deliveryTime.value.includes('72 hours')) {
            dueDate = moment(new Date(createdDate))
                .add(72, 'hours')
                .format('MM/DD/YYYY');
        }

        else if (deliveryTime.value.includes('48 hours')) {
            dueDate = moment(new Date(createdDate))
                .add(48, 'hours')
                .format('MM/DD/YYYY');
        }

        else if (deliveryTime.value.includes('24 hours')) {
            dueDate = moment(new Date(createdDate))
                .add(24, 'hours')
                .format('MM/DD/YYYY');
        }
        return dueDate;
    }

    async getSingleOrder(orderId) {
        return new Promise(async (resolve, reject) => {
            this.commonQueryService.FETCH_ORDER_BY_ID(orderId).valueChanges.subscribe(async (response: any) => {
                if (response) {
                    let orderData = response && response.data && response.data.allOrders && response.data.allOrders.nodes.length > 0 ? response.data.allOrders.nodes[0] : {}
                    var responseResult = JSON.parse(response && response.data && response.data.allOrders && response.data.allOrders.nodes && response.data.allOrders.nodes.length > 0 && response.data.allOrders.nodes[0] && response.data.allOrders.nodes[0].orderContent ? response.data.allOrders.nodes[0].orderContent : null);

                    responseResult['latitude'] = response.data.allOrders.nodes[0].latitude;
                    responseResult['longitude'] = response.data.allOrders.nodes[0].longitude;
                    responseResult['productId'] = response.data.allOrders.nodes[0].productId;
                    responseResult['productName'] = decodeURIComponent(response.data.allOrders.nodes[0].productByProductId.productName);
                    responseResult['contactName'] = response.data.allOrders.nodes[0].contactName;
                    responseResult['contactDate'] = response.data.allOrders.nodes[0].contactDate;
                    responseResult['contactEmail'] = response.data.allOrders.nodes[0].contactEmail;
                    responseResult['contactPhone'] = response.data.allOrders.nodes[0].contactPhone;
                    responseResult['projectInfo'] = response.data.allOrders.nodes[0].projectInfo;
                    responseResult['haveMorePics'] = response.data.allOrders.nodes[0].haveMorePics;
                    responseResult['notes'] = response.data.allOrders.nodes[0].notes;
                    responseResult['sku'] = decodeURIComponent(response.data.allOrders.nodes[0].productByProductId.sku);
                    responseResult['statusId'] = response.data.allOrders.nodes[0].statusId ? response.data.allOrders.nodes[0].statusId : orderData && orderData.statusId ? orderData.statusId : null;
                    responseResult['status_unique_name'] = orderData && orderData.statusByStatusId && orderData.statusByStatusId.statusName ? orderData.statusByStatusId.statusName : null,
                        responseResult['couponByCouponId'] = orderData && orderData.couponByCouponId ? orderData.couponByCouponId : null,
                        responseResult['productByProductId'] = orderData && orderData.productByProductId ? orderData.productByProductId : null,

                        this.currentOrderChanged.next(responseResult);

                    var solEmail = responseResult ? _.find(responseResult.meta_data, { key: checkoutFields.solEmail }) : ''; // Solution estimate email
                    solEmail ? this.solutionEmailChanges.next(solEmail.value) : this.solutionEmailChanges.next('');

                    var buyerProperty = responseResult ? _.find(responseResult.meta_data, { key: checkoutFields.buyerProperty }) : ''; // Buyer property
                    buyerProperty ? this.buyerPropertyChanges.next(buyerProperty.value) : this.buyerPropertyChanges.next('');

                    var agentRole = responseResult ? _.find(responseResult.meta_data, { key: checkoutFields.agentRole }) : ''; // Buyer agent / seller agent
                    agentRole ? this.clientRoleChange.next(agentRole.value) : this.clientRoleChange.next('');

                    var propertyRole = responseResult ? _.find(responseResult.meta_data, { key: checkoutFields.propertyRole }) : ''; // Buyer  / seller
                    propertyRole ? this.clientPropertyRoleChange.next(propertyRole.value) : this.clientPropertyRoleChange.next('');

                    var clientName = responseResult ? _.find(responseResult.meta_data, { key: checkoutFields.clientName }) : ''; //Client name
                    clientName ? this.clientNameChange.next({ loading: false, name: clientName.value }) : this.clientNameChange.next({ loading: false, name: '' });

                    var agentName = responseResult
                        ? _.find(responseResult.meta_data, { key: checkoutFields.agentName })
                        : 'nill'; // Agent Name
                    var agentEmail = responseResult
                        ? _.find(responseResult.meta_data, { key: checkoutFields.agentEmail })
                        : 'nill'; // Agent Email
                    var clientPropertyRole = responseResult
                        ? _.find(responseResult.meta_data, { key: checkoutFields.propertyRole })
                        : 'nill'; // clientPropertyRole Name
                    var agentType = responseResult
                        ? _.find(responseResult.meta_data, { key: checkoutFields.agentRole })
                        : 'nill'; // agentType Name
                    var specificItems = responseResult
                        ? _.find(responseResult.meta_data, { key: checkoutFields.itemList })
                        : 'nill'; // specific itemList
                    var invoiceEmail = responseResult ? _.find(responseResult.meta_data, { key: checkoutFields.customInvoiceClientEmail }) : ''; // Solution  email
                    var invoiceName = responseResult ? _.find(responseResult.meta_data, { key: checkoutFields.customInvoiceClientName }) : ''; // invoice name
                    //product name
                    let product = responseResult && responseResult.line_items.length > 0 ? responseResult.line_items[0].sku : '';
                    let product_name = (responseResult && responseResult.line_items.length > 0) &&
                        product == this.spekwoValues.prouct1 ? this.spekwoValues.HIQFULL :
                        product == this.spekwoValues.prouct2 ? this.spekwoValues.INSPECTIONCALL :
                            product == this.spekwoValues.prouct3 ? this.spekwoValues.GCCONSULTING :
                                product == this.spekwoValues.prouct5 ? this.spekwoValues.RJCZPSJ :
                                    product == this.spekwoValues.prouct4 ? this.spekwoValues.CGPYWCK : '';
                    var deliveryTime =
                        responseResult.line_items && responseResult.line_items.length > 0
                            ? _.find(responseResult.line_items[0].meta_data, {
                                key: this.checkoutFields.deliveryTime,
                            })
                            : null;
                    if (product == this.spekwoValues.prouct1 || product == this.spekwoValues.prouct4 || product == this.spekwoValues.prouct5) {
                        var check =
                            responseResult.line_items && responseResult.line_items.length > 0
                                ? _.find(responseResult.line_items[0].meta_data, {
                                    key: this.checkoutFields.deliveryTime,
                                })
                                : null;
                        let paiAmount = responseResult && responseResult.total ? responseResult.total : 0.00;
                        let discount = responseResult && responseResult.coupon_lines.length > 0 && responseResult.coupon_lines[0].discount ? responseResult.coupon_lines[0].discount : 0.00;
                        let couponData = orderData && orderData.couponByCouponId ? orderData.couponByCouponId : {};
                        let productData = orderData && orderData.productByProductId ? orderData.productByProductId : {};
                        if (discount === 0 || discount === 0.00) {
                            discount = couponData && couponData.couponAmount ? couponData.couponAmount : 0.00;
                        }

                        if (!product) {
                            product = productData && productData.sku ? productData.sku : "";
                        }

                        let productAmount = productData && productData.productPrice ? productData.productPrice : 0.00;
                        if (product == this.spekwoValues.prouct1) {
                            this.dueDate = this.calcDueDate(deliveryTime, responseResult.date_created);
                        }
                        else if (product == this.spekwoValues.prouct4 || product == this.spekwoValues.prouct5) {
                            this.dueDate = this.calcDueDate(deliveryTime, responseResult.date_created);
                        }
                    } else if (
                        product == this.spekwoValues.prouct2 ||
                        product == this.spekwoValues.prouct3
                    ) {
                        var check = _.find(responseResult.meta_data, {
                            key: this.checkoutFields.apptDate,
                        });

                        this.dueDate = check
                            ? moment(moment(check.value, 'DD/MM/YYYY').toDate()).format(
                                'MM/DD/YYYY'
                            )
                            : '';

                    }
                    let orderDetails = {
                        id: responseResult && responseResult.id ? responseResult.id : null,
                        agentName: agentName && agentName.value ? agentName.value : '',
                        agentEmail: agentEmail && agentEmail.value ? agentEmail.value : '',
                        nodeId: response.data.allOrders.nodes[0] && response.data.allOrders.nodes[0].nodeId ? response.data.allOrders.nodes[0].nodeId : null,
                        first_name: responseResult ? responseResult.billing.first_name : '',
                        last_name: responseResult ? responseResult.billing.last_name : '',
                        city: responseResult ? responseResult.billing.city : '',
                        state: responseResult ? responseResult.billing.state : '',
                        country: responseResult ? responseResult.billing.country : '',
                        postcode: responseResult ? responseResult.billing.postcode : '',
                        email: responseResult ? responseResult.billing.email : '',
                        phone: responseResult ? responseResult.billing.phone : '',
                        clientPropertyRole: clientPropertyRole && clientPropertyRole.value ? clientPropertyRole.value : '',
                        agentType: agentType && agentType.value ? agentType.value : '',
                        clientName: clientName && clientName.value ? clientName.value : '',
                        buyerProperty: buyerProperty ? buyerProperty.value : '',
                        solEmail: solEmail && solEmail.value ? solEmail.value : '',
                        specificItems: specificItems && specificItems.value ? specificItems.value : [],
                        dueDate: this.dueDate,
                        createdVia: responseResult && responseResult.created_via ? responseResult.created_via : '',
                        totalAmount: responseResult && responseResult.total ? Number(responseResult.total) : '',
                        invoiceEmail: invoiceEmail && invoiceEmail.value ? invoiceEmail.value : '',  //Invoice client email
                        invoiceName: invoiceName && invoiceName.value ? invoiceName.value : '',
                        product_name: product_name,
                        statusId: responseResult.statusId,
                        status_unique_name: responseResult.status_unique_name,
                    }
                    this.singleOrderChanges.next({
                        data: orderDetails,
                        orderInfo: response.data.allOrders.nodes[0],
                    });
                    await _.each(responseResult.line_items, item => {

                        this.orderTypeChange.next(this.spekwoValues[item.sku]);

                        if (responseResult.line_items[0].meta_data.length > 0) {
                            //Get delivery time of product - Spekwo
                            //If exist set correct type

                            _.each(responseResult.line_items[0].meta_data, (item, key) => {

                                //Old order
                                if (item.key == "Delivery time") {
                                    this.orderProductChange.next(item.value); // delivery time
                                }

                                // New order details
                                if (item.key == '_tmcartepo_data') {
                                    //Get pdf file link
                                    var check = _.find(item.value, { name: "PDF" });

                                    this.pdfLinkFromCheckout.next({ loading: false, data: check ? check.value : '' })
                                }

                            })

                        } else {
                            //If not set empty value
                            this.orderProductChange.next(''); // delivery time
                            // Previous order has value & current order has no meta data means takes old pdf file to hide use this
                            this.pdfLinkFromCheckout.next({ loading: false, data: '' })
                        }
                    })
                    resolve(responseResult);
                }
                else {
                    reject(response);
                }
            }, reject)
        });
    }

    //getting dump response - temporarily not use
    getDumpResponse(orderId, pdfLink) {
        // this.PdfLinkChange = pdfLink.replace(/['"]+/g, '')
        return new Promise((resolve, reject) => {
            this.http.get(this.apiCalls.ocrResponse + '?order_id=' + orderId + '&link=' + pdfLink)
                .subscribe((res: Response) => {
                    resolve(res);
                }, reject);
        });
    }

    //getting solution type responAnyFnse
    getSolutionTypeResponse() {

        return new Promise((resolve, reject) => {
            this.http.get(this.apiCalls.getSolutionType)
                .subscribe((response) => {
                    // console.log('response', response);
                    resolve(response);
                }, reject)

        });
    }

    //getting Description and cost  response
    getDescCostResponse(catType, subCatType) {
        var url = this.apiCalls.getDescCost + '?category=' + catType + '&&subcategory=' + subCatType;
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .subscribe((response: JSON) => {
                    resolve(response);
                }, reject)
        });
    }

    deleteContact(allCategories, selectedCategory): Promise<any> {
        return new Promise((resolve, reject) => {
            const contactIndex = allCategories.indexOf(selectedCategory);
            allCategories.splice(contactIndex, 1);
            this.onCategoryChanged.next(allCategories);
        });
    }

    /** Send report id to client */
    sentReportId(reportId, orderResponse, subjectPropertyAddress, solutionEstimateEmails, roleId?, userId?, orderId?) {
        return new Promise((resolve, reject) => {
            let arr = solutionEstimateEmails.filter(item => item);
            const params = {
                email: arr, //All 3 emails(your email,solution email,alter email)
                // email: isAlterEmail == 'yes' ? alterEmail : alterEmail ? alterEmail : orderResponse.billing.email, //Check solution email given .If not take billing email
                firstName: encodeURIComponent(orderResponse.billing.first_name),
                reportId: encodeURIComponent(reportId),
                subjectPropertyAddress: encodeURIComponent(subjectPropertyAddress) //Pass meta data alone,to avoid "too long query length"
            }
            // "54155 Lansdale Dr Apt`:,.=- ~!@#$%^&*()_+{}|:<>?#E"

            const finalJson = JSON.stringify(params);
            // const finalJson = params;
            // console.log('finalJson!', finalJson);

            this.http.get(this.apiCalls.passReportIdToClient + '?finalJson=' + finalJson)
                .subscribe(data => {
                    // console.log('response!', data);
                    this.auditHistoryFunCall('Success', roleId, userId, orderId, params, "email_send_approve_to_client", "Approved to client email conformation send");
                    resolve(data);
                }, err => {
                    this.auditHistoryFunCall('Failed', roleId, userId, orderId, params, "email_send_approve_to_client", "Approved to client email conformation send");
                    console.log('error!', err);
                    reject(err);
                })
        })
    }

    /** Send sms */
    sendSMS(name, phone, roleId, userId, orderId) {
        return new Promise((resolve, reject) => {
            const params = {
                to: "+1" + (phone ? phone.toString() : "4804091859"),
                smsContent: spekwo.hiMsge + name + "\n" + spekwo.smsDefaultContent1 + "\n" + spekwo.smsDefaultContent2 + "\n" + spekwo.smsDefaultContent3 + "\n" + spekwo.smsDefaultContent4 + "\n" + spekwo.smsDefaultContent5 + "\n" + spekwo.smsDefaultContent6
            }
            const finalJson = JSON.stringify(params);
            this.http.get(this.apiCalls.sendSMSBETA + '?&finalJson=' + finalJson)
                .subscribe(data => {
                    this.auditHistoryFunCall('Success', roleId, userId, orderId, params, "sms_send_approve_to_client", "Approved to client sms conformation send");
                    resolve(data);
                }, err => {
                    if (err && err.status && (parseInt(err.status) == 200)) {
                        this.auditHistoryFunCall('Success', roleId, userId, orderId, params, "sms_send_approve_to_client", "Approved to client sms conformation send");
                        resolve(err);
                    }
                    else {
                        this.auditHistoryFunCall('Failed', roleId, userId, orderId, params, "sms_send_approve_to_client", "Approved to client sms conformation send");
                        console.log('error!', err);
                        reject(err);
                    }
                })
        })
    }

    submitPayment(tokenId, payment) {
        return new Promise((resolve, reject) => {
            const params = {
                stripeToken: tokenId,
                payment
            }
            const finalJson = JSON.stringify(params);

            this.http.get(this.apiCalls.payment + '?finalJson=' + finalJson)
                .subscribe(data => {
                    console.log('charge!', data);
                    resolve(data);
                }, err => {
                    console.log('error!', err);
                    reject(err);
                })
        })
    }


    //Check current report ,already sumitted by client,if it is ,should not edit or delte by admin
    checkOrderStatus(currentOrderId) {
        return new Promise((resolve, reject) => {
            this.scheduleQueryService
                .GET_REQUEST_STATUS_BY_ORDER_ID(currentOrderId)
                .valueChanges
                .subscribe(({ data }) => {
                    var responseData = data && data.allScheduleRequests.edges;
                    resolve(responseData);
                }, (err) => {
                    reject(err);
                });
        });
    }

    GetUserNameById(userId) {
        return new Promise((resolve, reject) => {
            this.userQueryService
                .GET_USER_BASED_UID(userId)
                .valueChanges
                .subscribe(({ data }) => {
                    var responseData = data.allUsers.edges;
                    resolve(responseData);
                }, err => {
                    reject(err);
                });
        });
    }

    fileUpload(payload, orderId) {
        //Without base64 content using formData
        let formData = new FormData();
        formData.append('file', payload);
        return new Promise((resolve, reject) => {
            const url = this.apiCalls.manualUpload + '?orderId=' + orderId;
            this.http.post(url, formData)
                .subscribe(data => {
                    resolve(data);
                    // this.fileProcessing(orderId)
                    //     .then(() => {
                    //         console.log('isProcessLoading3');
                    //         resolve(data);
                    //     })
                    //     .catch(err => {
                    //         console.log('err', err);
                    //         reject(err);
                    //     })
                }, error => {
                    reject(error);
                })
        })
        //With base64 content using formData -not completed
        // return new Promise((resolve, reject) => {
        //     this.http.get('http://172.104.179.88/SpekwoRest/fileUpload.php?orderId=' + orderId + '&&basevalue=' + payload)
        //         .subscribe(data => {
        //             resolve(data);
        //         }, error => {
        //             reject(error);
        //         })
        // })
    }

    fileProcessing(orderId) {
        console.log('isProcessLoading4');
        return new Promise((resolve, reject) => {
            this.http.get(this.apiCalls.manualFileProcessing + '?order_id=' + orderId)
                .subscribe((res: Response) => {
                    console.log('response', res);
                    resolve(res);
                }, reject);
        });

    }

    //Get rating of current order if client provided
    getRating(orderId) {
        return new Promise((resolve, reject) => {
            this.ratingQueryService.GET_CURRENT_ORDER_RATING(orderId)
                .valueChanges
                .subscribe((res: any) => {
                    var responseData = res.data.allRatings.edges;
                    resolve(responseData);
                }, err => {
                    reject(err);
                })
        })
    }

    //Get current user emil
    getCurrentUserEmail() {
        return new Promise((resolve, reject) => {
            this.userQueryService.GET_CURRENT_USER()
                .subscribe((res: any) => {
                    if (res.data.allUsers.edges.length > 0) {
                        var responseEmail = res.data.allUsers.edges[0].node.email;
                        resolve(responseEmail);
                    }
                }, err => {
                    reject(err);
                })

        })

    }

    /**  Get charge percent to make payment*/
    getChargePercentage() {
        return new Promise((resolve, reject) => {
            this.settingQueryService
                .GET_CHARGE_PERCENTAGE()
                .valueChanges
                .subscribe((data: any) => {
                    var responseData = data.data.allSettings.edges;
                    if (responseData.length > 0) {
                        this.chargePercent.next(responseData[0].node.percentage);
                        resolve(responseData);
                    }
                })
        })
    }

    /** Check OCrR processed for this order or not */

    checkDocProcess(orderId) {

        return new Promise((resolve, reject) => {
            this.ocrDumpsQueryService
                .CHECK_DOC_PROCESS(orderId)
                .valueChanges
                .subscribe((response: any) => {

                    if (response.data &&
                        response.data.allOcrDumps &&
                        response.data.allOcrDumps.edges) {

                        resolve(response.data.allOcrDumps.edges);
                    }

                }, reject)
        })
    }

    /** Get toggled report by client */
    getClientAcceptedSolution(orderId) {

        return new Promise((resolve, reject) => {
            //Once order available means , listed order details
            this.scheduleQueryService
                .GET_REQUEST_STATUS_BY_ORDER_ID(orderId)
                .valueChanges
                .subscribe((response: any) => {

                    var reqResponseData = response
                        && response.data
                        && response.data.allScheduleRequests.edges;

                    //Check order submitted by client
                    if (reqResponseData.length > 0) {

                        //If order present, get status of orders
                        this.solutionMasterQueryService.GET_ACCEPTED_REPORTS(orderId)
                            .valueChanges
                            .subscribe(({ data }) => {

                                if (data &&
                                    data.allReportSolutionMasters &&
                                    data.allReportSolutionMasters.edges.length > 0) {

                                    var masterResponse = data.allReportSolutionMasters.edges;
                                    var returnObject = {
                                        masterResponse,
                                        reqResponseData,
                                        loading: false
                                    }
                                    this.toggledSolution.next(returnObject);

                                    resolve(returnObject);

                                }

                            }, () => {
                                this.toggledSolution.next({ loading: false });
                                resolve({});
                            })

                    } else {
                        this.toggledSolution.next({ loading: false });
                        resolve({});
                    }

                }, () => {

                    reject;
                })

        })
    }

    /*Store report reviews */
    reportReViewDetails(orderId, insReportId) {

        return new Promise((resolve, reject) => {

            this.insReportSrcQueryService.IS_INS_REPORT_EXIST(orderId)
                .valueChanges
                .subscribe((response: any) => {
                    //Get already report generated with id
                    if (response &&
                        response.data &&
                        response.data.allInspectionReportsSrcs &&
                        response.data.allInspectionReportsSrcs.edges.length == 0) {
                        //Create Inspection src report
                        this.CreateInspectionReport(orderId, insReportId)
                            .then(() => {

                                this.bookingsQueryService.UPDATE_SCHEDULE_BOOKING_BY_ORDERID(insReportId, orderId)

                                var object = {
                                    status: 'success',
                                    insReportId: insReportId
                                }
                                resolve(object)
                            }).catch(() => {
                                var object = {
                                    status: 'failed',
                                    insReportId: insReportId
                                }
                                resolve(object)
                            });
                    } else {
                        var object = {
                            status: 'success',
                            insReportId: response.data.allInspectionReportsSrcs.edges[0].node.insReportId
                        }
                        resolve(object)
                    }
                }, () => {
                    var object = {
                        status: 'failed',
                        insReportId: insReportId
                    }
                    resolve(object)
                })

        })

    }

    /** Get last review id */
    getLastReviewId() {

        return new Promise((resolve, reject) => {
            this.reportReviewQueryService
                .GET_LAST_REVIEW_ID()
                .valueChanges
                .subscribe((response: any) => {
                    if (response &&
                        response.data &&
                        response.data.allReportReviewDetails &&
                        response.data.allReportReviewDetails.edges.length > 0) {
                        response.data.allReportReviewDetails.edges.forEach((lastValue, key) => {
                            resolve(lastValue.node.reviewId)
                        })
                    }
                    else {
                        resolve(0);
                    }

                }, (err) => {
                    reject(err);
                });
        })

    }

    insReportIdOfOrder(currentOrderId) {
        this.insReportSrcQueryService.IS_INS_REPORT_EXIST(currentOrderId)
            .valueChanges
            .subscribe(response => {
                if (response &&
                    response.data &&
                    response.data.allInspectionReportsSrcs &&
                    response.data.allInspectionReportsSrcs.edges.length > 0) {
                    this.insReportIdChange.next(response.data.allInspectionReportsSrcs.edges[0].node)
                } else {
                    this.insReportIdChange.next(null)
                }

            }, () => {
                this.insReportIdChange.next(null)
            })
    }

    /**Get ocr document for each order */
    GetOcrDocument(orderId) {
        console.log('orderId', orderId);
        let url = this.apiCalls.ocrDocFetch;

        return new Promise((resolve, reject) => {

            this.http.get(url + '?orderId=' + orderId)
                .subscribe((response: any) => {

                    this.ocrDocumentChange.next({ loading: false, data: response });

                    resolve(response);

                }, reject);

        });
    }

    /**Create Solution Master  */
    CreateSolutionMaster(currentOrderId, lastReviewId, insReportId, mainCategory, subCategory, allElement, keywords) {
        // console.log('orderId', currentOrderId);

        return new Promise((resolve, reject) => {

            this.reportReviewQueryService.CREATE_REPORT_SOLUTION_MUTATION_WITHOUT_ID(currentOrderId,
                lastReviewId, insReportId,
                mainCategory, subCategory, allElement, keywords)
                .subscribe((response) => {
                    resolve(response);
                }, reject);

        });
    }

    /**Create Solution Master with id  */
    CreateSolutionMasterWithId(currentOrderId, lastReviewId, insReportId, matchQuery, allElement) {
        // console.log('orderId', currentOrderId);

        return new Promise(async (resolve, reject) => {
            this.reportReviewQueryService.CREATE_REPORT_SOLUTION_MUTATION(currentOrderId,
                lastReviewId,
                insReportId,
                matchQuery, allElement)
                .subscribe(() => {
                    resolve('success');
                }, reject);

        });
    }

    // Create Inspection src report
    CreateInspectionReport(currentOrderId, randomId) {
        // console.log('orderId', currentOrderId);

        return new Promise((resolve, reject) => {

            this.insReportSrcQueryService.CREATE_INSPECTION_REPORT_MUTATION(currentOrderId, randomId)
                .subscribe(() => {
                    resolve('success');
                }, reject)

        });
    }

    //Updating or creating solution description
    storingKeywordsInDB(solutions: SolutionDescriptionNodes, selectedKeywordId?: number) {

        var solutionInputs: SolutionDescriptionNodes = {
            'keyword': [],
            'solution': '',
            'cost': 0,
        }


        //Assigning input fileds
        // solutionInputs.keyword = searchKeyWords;
        // solutionInputs.solution = solution;
        // solutionInputs.cost = totalCost;

        //Storing keywords to backend if the id exited create new or update
        if (selectedKeywordId) {
            solutionInputs.id = selectedKeywordId;
        }

        return new Promise((resolve, reject) => {
            this.solutionDescriptionRes = (selectedKeywordId) ?
                this._solutionDescriptionQueryService.UPDATE_SOLUTION_DESCRIPTION(solutions) :
                this._solutionDescriptionQueryService.CREATE_SOLUTION_DESCRIPTION(solutions);

            this.solutionDescriptionRes.subscribe(() => {
                resolve('success');
            }, reject)
        });

    }
    //create role based user
    CREATE_SOLUTION_ESTIMATE_USER(currentOrderId, insReportId) {

        return new Promise((resolve, reject) => {

            let userId = localStorage.getItem('userUID');
            let role = localStorage.getItem('role');
            this.authService.getRoleId(role)
                .then(roleId => {
                    //create user role data via query
                    this.solutionEstimateUsersQueryService.CREATE_SOLUTION_ESTIMATE(currentOrderId, userId, insReportId, roleId)
                        .subscribe((response) => {
                            if (response) {
                                console.log('result done1', response);
                                resolve(response);
                            } else {
                                reject;
                            }
                        }, reject);

                }).catch(() => {
                    reject;
                });


        });

    }

    getAcceptedClientOrders(orderId) {
        return new Promise((resolve, reject) => {
            this.solutionMasterQueryService.GET_ACCEPTED_REPORTS_WITHOUT_STATUS(orderId).valueChanges
                .subscribe((response: any) => {
                    resolve(response);
                }, reject)
        });
    }

    fliterItemsFromSolution(orderId, itemArray) {
        return new Promise((resolve, reject) => {
            this.reportReviewQueryService.FLITER_ITEM_FROM_SOLUTIONS(orderId, itemArray)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject)
        });
    }

    auditHistoryFunCall(status, roleId, userId, orderId, newData, auditType, logsDesc) {

        let auditLogPayload = {
            roleId: roleId,
            userId: userId,
            orderId: Number(orderId),
            newData: newData,
            oldData: null,
            auditType: auditType,
            logsDesc: logsDesc,
            platform: "Executive Dashboard",
            status: status,
            createdAt: "now()"
        };
        this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/solutionForm.service.ts